(function () {
  /**
   * Cooldown
   */
  let searchCooldown
  
  /**
   * Search result product template
   */
  const product = (product, lang) => { 
    return `<li class="odd:bg-gray-50 hover:bg-[#deefdf]">
      <a href="${product.permalink}" title="${product.title}" class="flex flex-row items-center py-3 px-4 gap-3 w-full underline text-darkblue-500 hover:text-blue-500">
        <img src="${product.product_image}" class="w-12 h-12 rounded-lg" alt="${product.title}" />
        <span class="text-sm text-truncate">${product.title}</span>
      </a>
    </li>`
  }

  /**
   * Search result list
   */
  const resultlist = (hits, lang) => { 
    let result = '<ul class="list-none">'
    for (const hit of hits) {
      if (hit.permalink !== null && hit.product_image !== null && hit.title !== null) {
        result += product(hit)
      }
    }
    result += '</ul>'
    return result
  }

  /**
   * Nothing found template
   */
  const nothingfound = (string) => {
    return `<ul class="list-none"><li><span class="py-3 px-4">${string}</span></li></ul>`
  }

  /**
   * Search action
   */
  const search = ($input) => {
    const input = $input.value.trim()
    const result_wrapper = document.querySelector('#resultlist')
    const outer_result_wrapper = document.querySelector('#resultlistwrapper')

    if (!input) {
      result_wrapper.innerHTML = ''
      result_wrapper.classList.remove('!translate-y-0', '!pointer-events-auto', '!opacity-100')
      outer_result_wrapper.classList.remove('!h-60', '!pointer-events-auto')
      return
    }

    const lang = document.getElementById('old_lang').value || 'en'

    const form = new FormData();
    form.append('action', 'toypek_search_algolia');
    form.append('lang', lang );
    form.append('query', input );
    form.append('nonce', toypek_search_algolia.security );
    const params = new URLSearchParams(form);

    /**
     * Send search request to Algolia
     */
    fetch(toypek_search_algolia.ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
       'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data) {
        if (Object.prototype.hasOwnProperty.call(data, 'data') && data.success) {
          outer_result_wrapper.classList.add('!h-60', '!pointer-events-auto')
          result_wrapper.classList.add('!translate-y-0', '!pointer-events-auto', '!opacity-100')
          if (Object.prototype.hasOwnProperty.call(data.data, 'hits') && data.data.hits.length > 0) {
            const hits = data.data.hits
            result_wrapper.innerHTML = resultlist(hits)
          } else {
            result_wrapper.innerHTML = nothingfound(data.data.strings.no_results)
          }
        } 
      }
    })
    .catch((error) => {
      throw new Error(error)
    });
  };

  /**
   * Add search event listener
   */
  document.getElementById('algolia-search').addEventListener('input', (e) => {
    clearTimeout(searchCooldown)
    searchCooldown = setTimeout(() => {
      search(e.target)
    }, 300)
  })
}())